module.exports = __webpack_public_path__ + "static/media/sdplogo.438ee317.png";